import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  ICommonHttp,
  IHttpDelete,
  IHttpGet,
  IHttpPost,
  IHttpPut,
  IHttpPatch,
} from './common.http.model';
import Swal from 'sweetalert2';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

type ResponseType = {
  error: {
    Error: string[][];
  };
};

let API = environment.url;

let APICommon: ICommonHttp = {
  Autenticar: `/v1/Login/Autenticar`,
  Advertencia: `/v1/Advertencia`,
  ApontamentoHora: `/v1/ApontamentoHora`,
  DashboardRH: `/v1/Dashboard/RH`,
  DashboardEncarregado: `/v1/Dashboard/Encarregado`,
  Divergencia: `/v1/Divergencia`,
  DocumentoPessoa: `/v1/Pessoa/DocumentoPessoa`,
  EPI: `/v1/EPI`,
  EPI_Reed: `/v1/EPI_Reed`,
  FrenteTrabalho: `/v1/FrenteTrabalho`,
  Funcionario: `/v1/Funcionario`,
  Usuario: `/v1/Usuario`,
  Perfil: `/v1/Perfil`,
  PerfilNGestaAcesso: `/v1/Perfil/PerfilNGestaAcesso`,
  GestaoAcesso: `/v1/GestaoAcesso`,
  ImagemJustificativa: `/v1/ImagemJustificativa`,
  ImagemProjeto: `/v1/ImagemProjeto`,
  ImagemProjetoDisciplina: `/v1/ImagemProjetoDisciplina`,
  ImagemPessoa: `/v1/Pessoa/ImagemPessoa`,
  Projeto: `/v1/Projeto`,
  ProjetoDisciplina: `/v1/ProjetoDisciplina`,
  Pessoa: `/v1/Pessoa`,
  PessoaWithDocuments: `/v1/Pessoa/PessoaWithDocuments`,
  Disciplina: `/v1/Disciplina`,
  Acrescimo: `/v1/Acrescimo`,
  Materiais: `/v1/Material`,
};

let APIGet: Partial<IHttpGet> = {
  ...APICommon,
  DashboardRH: `/v1/Dashboard/RH`,
  PessoaByFilter: `/v1/Pessoa/ByFilter`,
  AdvertenciaById: `/v1/Advertencia/ById`,
  DivergenciaById: `/v1/Divergencia/ById`,
  FrenteTrabalhoByFilter: `/v1/FrenteTrabalho/GetByFilter`,
  EPIByFilter: `/v1/EPI/ByFilter`,
  EPIWithPessoa: `/v1/EPI/WithPessoa`,
  FrenteTrabalhoWithPessoa: `/v1/FrenteTrabalho/WithPessoa`,
  ApontamentosByFilters: `/v1/ApontamentoHora/ByFilters`,
  FuncionarioByFilter: `/v1/Funcionario/ByFilter`,
  FuncionarioByFilterXlsx: `/v1/Funcionario/ByFilter/ExportXlsx`,
  PerfilByFilter: `/v1/Perfil/ByFilter`,
  ProjetoByFilter: `/v1/Projeto/GetByFilter`,
  ProjetoGet: `/v1/Projeto/Get`,
  DisciplinaByFilter: `/v1/Disciplina/DisciplinaByFilter`,
  TipoPessoa: `/v1/Pessoa/TipoPessoa`,
  Licencas: `/v1/Licenca/Licencas`,
  LicencasCriadas: `/v1/Licenca/LicencasCriadas`,
  ApontamentoLog: `/v1/ApontamentoLog/Logs`,
  ApontamentoLogImagem: `/v1/ApontamentoLog/Imagem`,
  FuncionarioWithoutFrente: `/v1/FrenteTrabalho/FuncionarioWithoutFrente`,
  AjustesByFilters: `/v1/ApontamentoHora/AjustesByFilters`,
  ImagemLicencaPessoa: `/v1/Licenca/ImagemLicencaPessoa`,
  LicencaExportExcel: `/v1/Licenca/ExportExcel`,
  FornecedorByFilter: `/v1/Fornecedor/GetFornecedorByFilter`,
  PedidoByFilter: `/v1/Pedido/GetPedidoByFilter`,
  DiarioObraByFilter: `/v1/DiarioObra/GetDiarioObraByFilter`,
  DiarioObraById: `/v1/DiarioObra/GetDiarioObraById`,
};

let APIPost: Partial<IHttpPost> = {
  ...APICommon,
  AssociateEPIPessoa: `/v1/EPI_REED/AssociateEPIPessoa`,
  EPIByFilter: `/v1/EPI/ByFilter`,
  DashboardRHExcel: `/v1/Dashboard/RH/ExportXlsx`,
  TermoAceite: `/v1/ApontamentoHora/AceitarTermos`,
  CreateFrenteTrabalho: `/v1/FrenteTrabalho/CreateFrenteTrabalho`,
  AssociarEPI: `/v1/EPI/AssociateEPIPessoa`,
  AssociarFrenteTrabalho: `/v1/FrenteTrabalho/AssociarFrenteTrabalhoPessoa`,
  UsuarioNFuncionario: `/v1/Usuario/UsuarioNFuncionario`,
  ApontamentoHoraXlsx: `/v1/ApontamentoHora/ApontamentoHora/ExportXlsx`,
  AdvertenciaXslx: `/v1/ApontamentoHora/ApontamentoHoraAdvertencia/ExportXlsx`,
  ApontamentoMensalXlsx: `/v1/ApontamentoHora/ApontamentoHora/ExportXlsxByMonth`,
  EncarregadoXlsx: `/v1/Dashboard/Encarregado/ExportXlsx`,
  PerfilXlsx: `/v1/Perfil/ByFilter/ExportXlsx`,
  HorarioDivergente: `/v1/Divergencia/HorarioDivergente`,
  Recognize: `/v1/ReconhecimentoFacial/Recognize`,
  FaceTimekeeping: `/v1/ApontamentoHora/FaceTimekeeping`,
  DashboardRHXlsx: `/v1/Dashboard/RH/ExportXlsx`,
  ProjetoValidate: `/v1/Projeto/Validate`,
  ProjetoReview: `/v1/Projeto/Review`,
  CreateApontamentoHoraManual: `/v1/ApontamentoHora/CreateApontamentoHoraManual`,
  LicencaCriar: `/v1/Licenca/Criar`,
  CreateAdvertencia: `/v1/Advertencia/CreateAdvertencia`,
  CreateFornecedor: `/v1/Fornecedor/CreateFornecedor`,
  CreatePedido: `/v1/Pedido/CreatePedido`,
  CreateDiarioObra: `/v1/DiarioObra/CreateDiarioObra`,
  EsqueciSenha: `/v1/Login/EsqueciSenha`,
  PessoasApontamentoToXlsx: `/v1/ApontamentoHora/ApontamentoHora/ExportPessoasApontamentoToXlsx`,
  UploadApontamentoHora: '/v1/ApontamentoHora/UploadApontamentoHora',
};

let APIPut: Partial<IHttpPut> = {
  ...APICommon,
  AtualizarSenha: `/v1/Usuario/AtualizarSenha`,
  UpdateFrenteTrabalho: `/v1/FrenteTrabalho/UpdateFrenteTrabalho`,
  AssociatePessoaFrenteTrabalho: `/v1/Pessoa/AssociatePessoaFrenteTrabalho`,
  UpdateApontamentoHoraManual: `/v1/ApontamentoHora/UpdateApontamentoHoraManual`,
  UpdateAdvertencia: `/v1/Advertencia/UpdateAdvertencia`,
  UpdateDiarioObra: `/v1/DiarioObra/UpdateDiarioObra`,
  UpdateFornecedor: `/v1/Fornecedor/UpdateFornecedor`,
};

let APIDelete: Partial<IHttpDelete> = {
  ...APICommon,
  DeleteFrenteTrabalho: `/v1/FrenteTrabalho/DeleteFrenteTrabalho`,
  PessoaDesativar: `/v1/Pessoa/Desativar`,
  DisciplinaDelete: `/v1/Disciplina/Delete`,
  ProjetoDelete: `/v1/Projeto/Delete`,
};

let APIPatch: Partial<IHttpPatch> = {
  ...APICommon,
  PessoaDesativarAtivar: `/v1/Pessoa/DesativarAtivar`,
  TempoLicenca: `/v1/Licenca/TempoLicenca`,
  ApontamentoHoraAjuste: `/v1/ApontamentoHora/PatchApontamentoHoraAjusteHora`,
  FuncionarioStatus: `/v1/Funcionario/StatusFuncionario`,
  DiarioObraStatus: `/v1/DiarioObra/PatchDiarioObraStatus`,
  FornecedorStatus: `/v1/Fornecedor/PatchFornecedorStatus`,
  AtualizarSenha: `/v1/Usuario/AtualizarSenha`,
};

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  loader: boolean = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private location: Location
  ) {}

  getApiUrl(local: boolean): string {
    return local ? 'http://localhost:8080' : API;
  }

  handleSuccessResponse(url: string, successMessage: string) {
    this.loader = false;
    this.message(true, url, successMessage);
  }

  handleErrorResponse(url: string, error: any) {
    this.loader = false;
    this.message(false, url, undefined, error);
  }

  usePost(
    url: keyof IHttpPost,
    body: any,
    local = false,
    isNavigate: boolean = true
  ): Subscription {
    const apiUrl = this.getApiUrl(local);
    return this.http.post<any>(apiUrl + APIPost[url], body).subscribe({
      next: (response) => {
        if (response?.IsSuccess === false) {
          this.handleErrorResponse(url, response.Message);
          return;
        }
        this.handleSuccessResponse(url, 'Cadastro realizado com sucesso!');

        if (isNavigate) this.location.back();
      },
      error: (error) => {
        this.handleErrorResponse(url, error);
      },
    });
  }

  usePut(
    url: keyof IHttpPut,
    body: any,
    params?: any,
    local = false,
    isNavigate: boolean = true
  ): Subscription {
    const apiUrl = this.getApiUrl(local);
    return this.http
      .put<any>(apiUrl + APIPut[url], body, { params })
      .subscribe({
        next: (response) => {
          if (response?.IsSuccess === false) {
            this.handleErrorResponse(url, response.Message);
            return;
          }

          this.handleSuccessResponse(url, 'Edição realizada com sucesso!');
          
          if (isNavigate) this.location.back();
        },
        error: (error) => {
          this.handleErrorResponse(url, error);
        },
      });
  }

  useDelete(url: keyof IHttpDelete, params: any): Subscription {
    const apiUrl = this.getApiUrl(false);
    return this.http
      .delete<any>(apiUrl + APIDelete[url], { params })
      .subscribe({
        next: (response) => {
          if (response?.IsSuccess === false) {
            this.handleErrorResponse(url, response.Message);
            return;
          }
          this.handleSuccessResponse(url, 'Exclusão realizada com sucesso!');
        },
        error: (error) => {
          this.handleErrorResponse(url, error);
        },
      });
  }

  useGet(url: keyof IHttpGet, params?: any): Observable<any> {
    return this.http.get<any>(API + APIGet[url], { params });
  }

  usePostFilter(url: keyof IHttpPost, body: any): Observable<any> {
    return this.http.post<any>(API + APIPost[url], body);
  }

  usePatch(url: keyof IHttpPatch, body: any, params?: any): Observable<any> {
    return this.http.patch<any>(API + APIPatch[url] + '?id=' + params, body);
  }

  usePatchNoParams(url: keyof IHttpPatch, body: any): Observable<any> {
    return this.http.patch<any>(API + APIPatch[url], body);
  }

  private message(
    isSuccess: boolean,
    url: string,
    message?: string,
    response?: any
  ) {
    const title = isSuccess ? 'Sucesso!' : 'Alerta!';
    const icon = isSuccess ? 'success' : 'warning';
    const confirmButtonText = 'Ok';
    const confirmButtonColor = 'green';

    let errorMessage = '';

    if (!isSuccess && response) {
      try {
        if (response?.Message || response?.Error || response?.InnerMessage) {
          errorMessage = `
            ${response.Message || ''}
            ${response.Error ? `<br/>${response.Error}` : ''}
            ${
              response.InnerMessage
                ? `<br/><small>${response.InnerMessage}</small>`
                : ''
            }
          `.trim();
        } else {
          errorMessage =
            typeof response === 'string'
              ? response
              : 'Ocorreu um erro inesperado.';
        }
      } catch (error) {
        errorMessage =
          'Ocorreu um problema inesperado ao tentar realizar esta ação.';
      }
    }

    const html = errorMessage ? errorMessage : message;

    return Swal.fire({
      title,
      icon,
      html,
      confirmButtonText,
      confirmButtonColor,
    });
  }

  private getErrorMessage(
    response: ResponseType | string | string[]
  ): string[] {
    if (typeof response === 'string' || Array.isArray(response)) {
      return [response.toString()];
    } else if (response?.error?.Error) {
      return Object.values(response.error.Error).flat();
    } else {
      return [];
    }
  }

  private formatErrorMessages(messages: string[]): string {
    let formattedMessage = '<ul>';
    messages.forEach((message, index) => {
      formattedMessage += `<li>${message}</li>`;
    });
    formattedMessage += '</ul>';
    return formattedMessage;
  }
}
